import * as React from 'react';
import { connect } from 'react-redux';
import { withNavigation } from '../General/withNavigation';
import { setTiposPublicacion } from '../../actions/tiposPublicacionActions';
import Auth from '../../auth';
import ClickOutsideHandler from '../General/ClickOutsideHandler';
import {
    fetchSeller,
    editSeller,
    fetchIntegradores,
    fetchFacturaciones
} from '../../actions/sellersActions';
import TiposParaGuardar from './TipoPublicaciones/TiposParaGuardar';
import { selectSellerMerged } from '../../helper/sellerMergedSelector';

class Publicacion extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            didEdit: false,
            checked: 0,
            listaIdTiposPublicaciones: []
        }
    };

    componentDidMount() {

        this.props.fetchFacturaciones();
    }

    onRadioChange = (event) => {
        this.setState({
            checked: event.target.value,
            didEdit: true
        });

        let seller = this.props.seller;
        seller[event.target.name] = event.target.value;
        this.props.editSeller(seller);
    }

    onSubmitRadio = (e) => {
        e.preventDefault();
    }

    myChangeHandler = (event) => {
        this.setState({ didEdit: true });
        let seller = this.props.seller;
        seller[event.target.name] = event.target.value;
        this.props.editSeller(seller);
    }

    onSelectTipoPublicacion = () => {
        this.props.navigate("/Sellers/TiposPublicaciones/Select");
    }


    render() {
        const { isCategory, isAdminMod } = this.props.userType;
        let { seller } = this.props;

        let facturaciones = null;
        if (this.props.facturaciones !== undefined) {
            facturaciones = this.props.facturaciones.map((item, i) => {
                return (
                    <option key={i} value={item?.codigo}>{item.descripcion}</option>
                )
            })
        }

        return (
            <div className="tab-pane p-20 active" name="datos" id="home2" role="tabpanel">
                <div className="row">
                    <div className="col-sm-12 col-md-6 col-lg-6">
                        <div className="form-group">
                            <label>Tipo de Facturación</label>
                            <select
                                disabled={!isAdminMod}
                                className="form-control"
                                value={seller.tipoFacturacion?.codigo || ""}
                                onChange={this.myChangeHandler}
                                id="inlineFormCustomSelect"
                                name="tipoFacturacion"
                            >
                                {facturaciones}
                            </select>
                        </div>

                        <div className="form-group">
                            <label>URL push ordenes</label>
                            <input
                                type="text"
                                name="urlPushOrdenes"
                                className="form-control"
                                value={seller.urlPushOrdenes || ""}
                                onChange={this.myChangeHandler}
                                disabled={!isCategory && !isAdminMod}
                            />
                        </div>
                    </div>

                    <div className="col-sm-12 col-md-12 col-lg-12">
                        <TiposParaGuardar history={this.props.history} />
                        {(isCategory || isAdminMod) &&
                            <button
                                onClick={this.onSelectTipoPublicacion}
                                className="btn btn-sm background-rojo-megatone waves-light m-r-10"
                            >
                                Seleccionar Tipo de Publicación
                            </button>
                        }
                    </div>

                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    userType: state.general.userType,
    seller: selectSellerMerged(state),
    facturaciones: state.sellers.facturaciones,
    integradores: state.sellers.integradores,
});

export default withNavigation(connect(mapStateToProps, {
    fetchSeller,
    editSeller,
    fetchIntegradores,
    fetchFacturaciones
})(Publicacion));